import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "antd";
import { logoutToHome } from "../utils/authSession";

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <Button
      type="primary"
      onClick={() => logoutToHome(logout)}
    >
      Log Out
    </Button>
  );
};

export default LogoutButton;
